export default __webpack_public_path__ + "static/media/Security Lock.02cb544e.png";